import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { closeModal } from "../../redux/dispatchers/modalDispatcher";
import MODAL_REGISTRY from "./modalRegistry";

const ModalProvider = () => {
  const dispatch = useDispatch();
  const modals = useSelector((state) => state.modal ?? {});

  return (
    <>
      {Object.entries(modals).map(([id, slice]) => {
        const Component = MODAL_REGISTRY[id];
        if (!Component || !slice?.open) return null;
        return (
          <Component
            key={id}
            visible={slice.open}
            data={slice.data}
            onClose={() => dispatch(closeModal(id))}
          />
        );
      })}
    </>
  );
};

export default ModalProvider;
